<template>
  <div id="action-wrap">
    <h2 v-if="!forOverview">Stats</h2>
    <CharacterPhysicalAttributes />
    <CharacterSkills />
    <SaveButtons v-if="!forOverview" @clear="clearStats" />
  </div>
</template>

<script>
import CharacterPhysicalAttributes from './CharacterPhysicalAttributes.vue';
import CharacterSkills from './CharacterSkills.vue';
import SaveButtons from '../../util/SaveButtons';

// Skills, (√) Armor, (√) Hit Points, (√) Damage
export default {
  name: 'Stats',
  props: ['forOverview'],
  components: { 
    CharacterSkills, 
    CharacterPhysicalAttributes,
    SaveButtons 
  },
  methods: {
    clearStats() {
      this.$store.dispatch('clearCharacterStats');
    }
  }
} 
</script>

<style lang="css">
  #action-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 20px;
  }

  .action-physical-attributes {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
  }

  .action-physical-attributes * {
    text-align: center;
  }
  
  .action-physical-attributes > * > input {
    width: 2em;
    height: 2em;
    border-radius: 100%;
  }

  .action-hit-points {
    margin-right: -1em;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

</style>